import { render, staticRenderFns } from "./SelectValidFontTypeModal.vue?vue&type=template&id=289a9a97&scoped=true&"
import script from "./SelectValidFontTypeModal.vue?vue&type=script&lang=ts&"
export * from "./SelectValidFontTypeModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289a9a97",
  null
  
)

export default component.exports